import { Card, Box, Button } from '@material-ui/core';
import React from 'react';
import { useDataProvider, useNotify } from 'react-admin';

const DailyReport = () => {
    const notify = useNotify()
    const dataProvider = useDataProvider()
    
    const createReport = async () => {
        console.log('create daily report')
        try {
            await dataProvider.createDailyReport();
            notify('Daily report is being generated and will be sent to email: james@raffle-house.com', "info");
        } catch(err) {
            if (typeof err === "object" && err !== null) {
                const anyErr = err as any;
                if (anyErr.response?.status === 504 || anyErr.status === 504) {
                    notify('This report takes a long time to generate. It will be available in Report list after a while.', 'error', false, false, 15000);
                    return;
                }
                if (anyErr.data?.error) {
                    notify(anyErr.data.error, "error");
                    return;
                }
                if (err instanceof Error && err.message) {
                    notify(err.message, "error");
                }
            }
        } 
    }
    return(
        <Card elevation={0} className="reportsCardWrapper" >
        <Box style={{width:'50%'}} marginTop='2rem' display="flex" justifyContent="space-between">
            <Button 
                size="large" 
                className="getReportsBtn" 
                onClick={createReport}
            >
                Create Daily Report
            </Button>
        </Box>
    </Card>
    )
}

export default DailyReport;